import { createClient } from '@supabase/supabase-js';

// ── SUPABASE CLIENT ────────────────────────────────────────────
// Uses the official SDK so Storage, Auth, and DB all share
// the same session token automatically — no manual token passing.

const supabaseUrl  = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey  = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession:   true,
    detectSessionInUrl: true,   // catches magic link token from URL hash
  }
});

// ── AUTH HELPERS ───────────────────────────────────────────────

export async function sendMagicLink(email) {
  const { error } = await supabase.auth.signInWithOtp({
    email,
    options: {
      emailRedirectTo: process.env.REACT_APP_SITE_URL,
      shouldCreateUser: true,
    },
  });
  return { error };
}

export async function getSession() {
  const { data, error } = await supabase.auth.getSession();
  return { session: data?.session || null, error };
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();
  return { error };
}

export function onAuthStateChange(callback) {
  return supabase.auth.onAuthStateChange((event, session) => {
    callback(event, session);
  });
}

// ── CUSTOMER HELPERS ───────────────────────────────────────────

export async function getCustomerByEmail(email) {
  const { data, error } = await supabase
    .from('customers')
    .select('*')
    .eq('email', email)
    .single();
  return { profile: data, error };
}

export async function upsertCustomerProfile(profile) {
  const { data, error } = await supabase
    .from('customers')
    .upsert(profile, { onConflict: 'email', ignoreDuplicates: false })
    .select()
    .single();
  return { profile: data, error };
}

// ── LEADS HELPERS ──────────────────────────────────────────────

export async function getLeads() {
  const { data, error } = await supabase
    .from('leads')
    .select('*')
    .order('created_at', { ascending: false });
  return { leads: data || [], error };
}

export async function insertLead(lead) {
  const { data, error } = await supabase
    .from('leads')
    .insert(lead)
    .select()
    .single();
  return { lead: data, error };
}

export async function updateLeadStatus(id, updates) {
  const { error } = await supabase
    .from('leads')
    .update(updates)
    .eq('id', id);
  return { error };
}
